import type { AnalyticsEvent } from '../../analytics/types';

export type LogicAnalyticsEventName =
  | 'display_logic_matched'
  | 'answer_logic_matched'
  | 'question_variant_matched'
  | 'end_page_logic_matched'
  | 'question_viewed'
  | 'skip_logic_triggered';

export type LogicEventHistoryEntry = {
  eventName: LogicAnalyticsEventName;
  timestampMs: number;
  metadata: Record<string, unknown>;
};

export type LogicMatchCounts = {
  display: number;
  answer: number;
  variant: number;
  endPage: number;
  skip: number;
  viewed: number;
};

export type EndPageMatchType = 'conditional' | 'default' | 'fallback';

export function createInitialLogicMatchCounts(): LogicMatchCounts {
  return {
    display: 0,
    answer: 0,
    variant: 0,
    endPage: 0,
    skip: 0,
    viewed: 0,
  };
}

export function isLogicAnalyticsEvent(event: AnalyticsEvent): event is Extract<
  AnalyticsEvent,
  { eventName: LogicAnalyticsEventName | 'logic_session_summary' }
> {
  return (
    event.eventName === 'display_logic_matched' ||
    event.eventName === 'answer_logic_matched' ||
    event.eventName === 'question_variant_matched' ||
    event.eventName === 'end_page_logic_matched' ||
    event.eventName === 'question_viewed' ||
    event.eventName === 'skip_logic_triggered' ||
    event.eventName === 'logic_session_summary'
  );
}
